module.exports = __webpack_public_path__ + "static/overview-portrait-3@2x-88eba4aeacb4bbd1d55c6a43485865ef.jpg";